import { render } from "./blackList.vue?vue&type=template&id=4b7efd14&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"

import "./blackList.vue?vue&type=style&index=0&id=4b7efd14&scoped=true&lang=css"
import "./blackList.vue?vue&type=style&index=1&id=4b7efd14&lang=css"
script.render = render
script.__scopeId = "data-v-4b7efd14"

export default script